export default __webpack_public_path__ + "static/water_filter_b.e013b49e204c0f4ed585744516812147.png";